import { render } from "./NoGoalsPlaceholder.vue?vue&type=template&id=7930f844&scoped=true"
import script from "./NoGoalsPlaceholder.vue?vue&type=script&lang=js"
export * from "./NoGoalsPlaceholder.vue?vue&type=script&lang=js"

import "./NoGoalsPlaceholder.vue?vue&type=style&index=0&id=7930f844&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7930f844"

export default script